//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import drawer from 'nges-common/src/web/components/drawer/index.vue';

export default {
  components: { drawer },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    logLines() {
      if (!this.detail.build_detail) return [];
      return this.detail.build_detail.replace(/\r\n/g, '\n').split('\n');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getHighlightClass(line) {
      const lowerLine = line.toLowerCase();
      if (lowerLine.includes('error') || lowerLine.includes('fail')) {
        return 'highlight-error';
      }
      if (lowerLine.includes('warning') || lowerLine.includes('warn')) {
        return 'highlight-warning';
      }
      if (lowerLine.includes('success') || lowerLine.includes('done')) {
        return 'highlight-success';
      }
      if (lowerLine.startsWith('yarn') || lowerLine.includes('>') || lowerLine.includes('$')) {
        return 'highlight-command';
      }
      return '';
    },
  },
};
